import Skeleton from "react-loading-skeleton"
import FloatTitleCard from "../cards/floatTitleCard"

const BookingSkt = () => {
    return (
        <div className="tw-pt-3 tw-flex tw-flex-col tw-gap-4">

            <div className="tw-flex tw-items-center tw-gap-2">
                <Skeleton className="tw-w-24" />
                <Skeleton className="tw-w-24" />
            </div>

            <FloatTitleCard title="مشخصات مرکز درمانی">
                <div className="tw-flex tw-items-center tw-justify-between tw-mb-3">
                    <div className="tw-flex tw-gap-2 tw-items-center">
                        <Skeleton className="tw-size-[55px] tw-rounded-full" />
                        <div className="tw-flex tw-flex-col tw-justify-between">
                            <Skeleton className="tw-w-20 tw-h-4" />
                            <Skeleton className="tw-w-36 tw-h-4" />
                        </div>
                    </div>
                    <Skeleton className="tw-size-12" />
                </div>
                <Skeleton className="tw-w-1/4 h-2" />
                <Skeleton className="tw-w-1/3 h-2" />
                <Skeleton className="tw-w-1/5 h-2" />
            </FloatTitleCard>

            <FloatTitleCard title="مشخصات مراجعه کننده">
                <div className="tw-w-full tw-flex tw-items-center tw-gap-2 tw-justify-center tw-mb-8">
                    <Skeleton className="tw-w-40 tw-h-8 rounded-pill" />
                    <Skeleton className="tw-w-40 tw-h-8 rounded-pill" />
                </div>
                <div className="tw-grid tw-grid-cols-3 tw-gap-2">
                    <Skeleton className="tw-h-10" />
                    <Skeleton className="tw-h-10" />
                    <Skeleton className="tw-h-10" />
                </div>
            </FloatTitleCard>

            <FloatTitleCard title="صورت حساب">

                <div className="d-flex flex-column gap-2 w-100 border flex-shrink-0 flex-grow-1 w-25 border-bootstrap-gray-300 rounded p-2 background-bootstrap-gray-100">

                    <div className="tw-flex tw-items-center tw-justify-between">
                        <Skeleton className="tw-w-40 tw-h-5" />
                        <Skeleton className="tw-w-40 tw-h-5" />
                    </div>

                    <div className="tw-flex tw-items-center tw-justify-between tw-mt-2">
                        <Skeleton className="tw-w-40 tw-h-5" />
                        <Skeleton className="tw-w-40 tw-h-5" />
                    </div>

                    <div className="tw-w-full tw-h-px tw-rounded-full tw-my-2 background-bootstrap-gray-200"></div>

                    <div className="tw-flex tw-items-center tw-justify-between">
                        <Skeleton className="tw-w-40 tw-h-5" />
                        <Skeleton className="tw-w-40 tw-h-5" />
                    </div>

                </div>
            </FloatTitleCard>
        </div>
    )
}

export default BookingSkt